import { Link, usePage } from "@inertiajs/react"

import { Button } from "@/components/ui/button"

interface HomepageCtaProps {
  /** Subtitle text shown below the button for unauthenticated users */
  subtitle?: string
}

export function HomepageCta({
  subtitle = "If someone sent you here, they want you in.",
}: HomepageCtaProps) {
  const { auth } = usePage<{ auth: { user: unknown } }>().props
  const isAuthenticated = !!auth?.user

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-4 text-center">
      <p
        className="font-display mb-6 text-base tracking-[0.2em] uppercase md:text-lg"
        style={{
          color: "oklch(0.85 0.28 85)",
          textShadow:
            "0 0 16px oklch(0.85 0.28 85 / 0.5), 0 0 32px oklch(0.80 0.30 145 / 0.2)",
        }}
      >
        {isAuthenticated
          ? "The league awaits, coach."
          : "Invite only. You made the list."}
      </p>

      <Link
        href={isAuthenticated ? "/dashboard" : "/sign_in"}
        className="w-full max-w-sm"
      >
        <Button
          variant="default"
          className="font-display w-full py-4 text-xl tracking-[0.15em] uppercase md:text-2xl"
          style={{
            background:
              "linear-gradient(180deg, oklch(0.88 0.28 85), oklch(0.72 0.22 85))",
            color: "oklch(0.10 0.02 55)",
            boxShadow:
              "0 0 30px oklch(0.85 0.28 85 / 0.5), 0 0 60px oklch(0.85 0.28 85 / 0.25), 0 0 100px oklch(0.80 0.30 145 / 0.15), inset 0 1px 0 oklch(1 0 0 / 0.2)",
          }}
        >
          {isAuthenticated ? "Dashboard" : "Enter the League"}
        </Button>
      </Link>

      {!isAuthenticated && (
        <p className="mt-4 text-sm" style={{ color: "oklch(0.55 0.02 55)" }}>
          {subtitle}
        </p>
      )}
    </div>
  )
}
